// Catálogo de "ganchos" (hooks) del modo "Video con influencer" — cada gancho
// trae un `prompt` (instrucción para el backend), un clip de preview vertical
// (`videoUrl`, 9:16) y su thumbnail. Se fetchea de la tabla `video_hooks`.
//
// Tabla `video_hooks` (ver migración 20260630120000_video_hooks.sql):
//   id, nombre, prompt, video_url, thumbnail_url, descripcion, activo, created_at
//
// Mientras no haya filas cargadas, el `GanchoPicker` cae a slots placeholder
// (9:16) para reservar/visualizar el espacio.

import { supabase } from '../../lib/supabase';

export interface GanchoOption {
  /** PK de la tabla `video_hooks`. */
  id: string;
  /** Nombre visible del gancho (columna `nombre`). */
  nombre: string;
  /** Instrucción del gancho que usa el backend para armar la apertura. */
  prompt: string;
  /** URL del clip vertical (9:16) de preview. Opcional mientras no haya asset. */
  videoUrl?: string;
  /** Poster/thumbnail del clip. Opcional. */
  posterUrl?: string;
  /** Texto corto opcional (explicador / subtítulo). */
  descripcion?: string;
}

/**
 * Cantidad de slots placeholder (9:16) que muestra el picker mientras no
 * haya ganchos cargados — solo para reservar/visualizar el espacio.
 */
export const GANCHO_PLACEHOLDER_SLOTS = 4;

/**
 * Devuelve los ganchos activos de `video_hooks`, ordenados por `created_at`.
 * Mapea las columnas snake_case al shape `GanchoOption` que usa la UI.
 */
export async function fetchVideoHooks(): Promise<GanchoOption[]> {
  const { data, error } = await supabase
    .from('video_hooks')
    .select('id, nombre, prompt, video_url, thumbnail_url, descripcion')
    .eq('activo', true)
    .order('created_at');
  if (error || !data) {
    console.error('[ganchosCatalog] fetchVideoHooks error', error);
    return [];
  }
  return (data as any[]).map(
    (g): GanchoOption => ({
      id: String(g.id),
      nombre: (g.nombre as string) || 'Gancho',
      prompt: (g.prompt as string) || '',
      videoUrl: (g.video_url as string) || undefined,
      posterUrl: (g.thumbnail_url as string) || undefined,
      descripcion: (g.descripcion as string) || undefined,
    }),
  );
}
